interface GrowthActivityFeedEvent {
  type?: string | null;
  summary?: string | null;
  payload?: {
    receipt?: {
      summary?: string | null;
    } | null;
  } | null;
  actor?: {
    name?: string | null;
    type?: string | null;
  };
  issue?: {
    title?: string | null;
  };
}

function clean(value: string | null | undefined): string {
  return value?.trim() || '';
}

function promotedActivityText(event: GrowthActivityFeedEvent): string {
  if (event.type === 'work_log') return clean(event.summary);
  if (event.type === 'ship_receipt') return clean(event.payload?.receipt?.summary);
  return '';
}

export function getGrowthActivityFeedLabels(event: GrowthActivityFeedEvent) {
  const summary = clean(event.summary);
  const issueTitle = clean(event.issue?.title);
  const actorLabel = clean(event.actor?.name) || clean(event.actor?.type) || 'System';
  const workText = promotedActivityText(event);
  const primary = workText || issueTitle || summary || actorLabel;
  const detail =
    issueTitle && issueTitle !== primary
      ? issueTitle
      : summary && summary !== primary
        ? summary
        : actorLabel;

  return { primary, detail };
}
